import { toHHMMSS } from 'common/services/helpers';
import { getClassName } from 'common/utils';
import { isNil } from 'lodash';
import React, { useMemo } from 'react';
import './Controls.styles';

interface StreamTimesProps {
  currentTime?: number;
  duration?: number;
  visible?: boolean;
}
function StreamTimes(props: StreamTimesProps) {
  const currentTime = useMemo(
    () => (!isNil(props.currentTime) ? toHHMMSS(props.currentTime) : '-:-'),
    [props.currentTime]
  );
  const duration = useMemo(
    () => (!isNil(props.duration) ? toHHMMSS(props.duration) : '-:-'),
    [props.duration]
  );

  return (
    <div
      className={getClassName('stream-times-container', { visible: props.visible })}
      data-test-id="stream-times"
    >
      <span className="current-time">{currentTime}</span>
      <span className="duration">/ {duration}</span>
    </div>
  );
}

export default React.memo(StreamTimes);
